import styled from "styled-components";
import { Dropdown } from "antd";

import state_active from "./image/state_active.svg";
import state_default from "./image/state_default.svg";

const StyledDropdown = styled(Dropdown)`
  &.actions-menu-toggler {
    background: url(${state_default}) no-repeat;
    cursor: pointer;
    height: 25px;
    position: relative;
    width: 25px;

    &:hover,
    &.ant-dropdown-open {
      background: url(${state_active}) no-repeat;
    }
  }
`;

export default StyledDropdown;
